function setupSimTypeCompatibleChecker() {
    if (document.querySelector('.manufacturerSelect')) {
        fetch('/beta/ajax/fetch-sim-type-compatible-devices').
            then(response => response.json()).
            then((data) => {
                document.querySelectorAll('.manufacturerSelect').
                    forEach(function(manufacturerSelect) {
                        getUniqueManufacturers(data.data).forEach((item) => {
                            let option = document.createElement('option');
                            option.text = item.manufacturer;
                            manufacturerSelect.appendChild(option);
                        });

                        manufacturerSelect.addEventListener('change',
                            function(event) {
                                let selectedManufacturer = event.target.value;

                                document.querySelectorAll('.modelSelect').
                                    forEach(function(modelSelect) {
                                        while (modelSelect.options.length > 1) {
                                            modelSelect.remove(1);
                                        }

                                        let selectedModels = data.data.filter(
                                            function(product) {
                                                return product.manufacturer === selectedManufacturer;
                                            });

                                        selectedModels.forEach(function(item) {
                                            let option = document.createElement('option');
                                            option.text = item.model;
                                            modelSelect.appendChild(option);
                                        });
                                    });
                            });
                    });
            });
    }
}

function getUniqueManufacturers(products) {
    let uniqueManufacturers = {};
    products.forEach(function(product) {
        uniqueManufacturers[product.manufacturer] = product.manufacturer;
    });

    let uniqueManufacturerArray = Object.keys(uniqueManufacturers).map(function(key) {
        return {
            'manufacturer': key
        };
    });

    return uniqueManufacturerArray;
}

const eSimTypeCompatibleChecker = () => {
    document.addEventListener('DOMContentLoaded', function() {
        setupSimTypeCompatibleChecker();

        $('.esim-compatible-sim-only-title').click(function() {
            $('.esim-compatible-sim-only-checker').toggleClass('hide');
        });

        $('.esim-compatible-button-close').click(function() {
            $('.esim-compatible-sim-only-checker').addClass('hide');
        });
    });
};

export default eSimTypeCompatibleChecker;
